import httpClient from '../httpClient';
import {
  CreateDataRoomTermsAndConditionsPayload,
  DataRoomTermsAndConditions,
  UpdateDataRoomTermsAndConditionsPayload,
} from '../../models/DataRoomTermsAndConditions';

function getTermsAndConditions(dataRoomId: string) {
  return httpClient.get<DataRoomTermsAndConditions[]>(
    `data-room-terms-and-conditions/data-rooms/${dataRoomId}`,
  );
}

function addTermsAndConditions(
  dataRoomId: string,
  data: CreateDataRoomTermsAndConditionsPayload,
) {
  return httpClient.post<DataRoomTermsAndConditions>(
    `data-room-terms-and-conditions/data-rooms/${dataRoomId}`,
    data,
  );
}

function updateTermsAndConditions(
  dataRoomTermsAndConditionId: string,
  data: UpdateDataRoomTermsAndConditionsPayload,
) {
  return httpClient.patch<DataRoomTermsAndConditions>(
    `data-room-terms-and-conditions/${dataRoomTermsAndConditionId}`,
    data,
  );
}

export default {
  getTermsAndConditions,
  addTermsAndConditions,
  updateTermsAndConditions,
};
